import { Navigate, Route } from "react-router-dom";

import { GuestRoutesWrapper, ROUTES } from "@/app/router";
import { ForgotPassword, Login, ResetPassword } from "./screens";

export const GuestRouter = () => {
  return (
    <GuestRoutesWrapper>
      <Route path={ROUTES.LOGIN} element={<Login />} />

      <Route path={ROUTES.RESET_PASSWORD} element={<ResetPassword />} />
      <Route path={ROUTES.FORGOT_PASSWORD} element={<ForgotPassword />} />

      <Route path="*" element={<Navigate replace to={ROUTES.LOGIN} />} />
    </GuestRoutesWrapper>
  );
};
